import React from "react";
import Header from "../Global/Header";
import WebsiteBreadCrumbs from "../Global/WebsiteBreadCrumbs";
import Manimgsix from "./Manimgsix";
import Exploreallten from "../../Components/Explore/Exploreallten";
import Footer from "../Global/Footer";
import CompanyLogo from "../Global/CompanyLogo";
import { useEffect } from "react";

function Manimgsixmain() {
  useEffect(() => {
    document.title = "Modern Majestic Dark Suit | Crowd Approved Fashion";
  }, []);
  return (
    <div className="background-image body-color ">
      <Header />
      <WebsiteBreadCrumbs />
      <Manimgsix />
      <Exploreallten />
      <Footer />
      <CompanyLogo />
    </div>
  );
}

export default Manimgsixmain;
